export type ValueLabelOption = {
  value: string;
  label: string;
};

/* --------- TENANTS --------- */

export enum RevenovaTenant {
  Prosponsive = 'clservicesinc',
  Cooler = 'coolerlogisticsllc',
  /** Matches drumkit TenantGreatLakes; SF tenant URLs contain "greatlakes". */
  GreatLakes = 'greatlakes',
}

export enum AppointmentSuggestionPolicy {
  Suppress = 'suppress',
  ExplicitOnly = 'explicit-only',
  Legacy = 'legacy',
}

export const tenantAppointmentSuggestionPolicies: Partial<
  Record<RevenovaTenant, AppointmentSuggestionPolicy>
> = {
  [RevenovaTenant.Cooler]: AppointmentSuggestionPolicy.Suppress,
  [RevenovaTenant.GreatLakes]: AppointmentSuggestionPolicy.ExplicitOnly,
};

/* --------- MODE OPTIONS --------- */

export const defaultModeOptions: ValueLabelOption[] = [
  { value: 'TL', label: 'Truckload' },
  { value: 'LTL', label: 'LTL' },
  { value: 'Refrigerated', label: 'Refrigerated' },
  { value: 'Flatbed', label: 'Flatbed' },
  { value: 'Dry Van', label: 'Dry Van' },
];

export const coolerModeOptions: ValueLabelOption[] = [
  { value: 'Truckload', label: 'Truckload' },
  { value: 'LTL', label: 'LTL' },
  { value: 'Reefer', label: 'Reefer' },
  { value: 'Flatbed', label: 'Flatbed' },
  { value: 'RLTL', label: 'RLTL' },
];

/** Great Lakes rtms__Mode__c values. */
export const greatLakesModeOptions: ValueLabelOption[] = [
  { value: 'Truckload', label: 'Truckload' },
  { value: 'LTL', label: 'LTL' },
  { value: 'Reefer', label: 'Reefer' },
  { value: 'Flatbed', label: 'Flatbed' },
];

export const prosponsiveModeOptions: ValueLabelOption[] = [
  { value: 'TL-Dry Van', label: 'TL-Dry Van' },
  { value: 'TL-Refrigerated', label: 'TL-Refrigerated' },
  { value: 'TL-Flatbed', label: 'TL-Flatbed' },
  { value: 'LTL', label: 'LTL' },
];

/* --------- WEIGHT UNITS --------- */
export const weightUnitsList: string[] = ['lbs', 'kg'];

/* --------- CURRENCY --------- */
export const currencyList: string[] = ['USD'];

/* --------- PRICING (serviceType) --------- */
export const pricingOptions: ValueLabelOption[] = [
  { value: 'Spot', label: 'Spot' },
  { value: 'Contract', label: 'Contract' },
  { value: 'Fixed', label: 'Fixed' },
];
